import { render, staticRenderFns } from "./OtherRepay.vue?vue&type=template&id=f2903ad6&scoped=true&"
import script from "./OtherRepay.js?vue&type=script&lang=js&"
export * from "./OtherRepay.js?vue&type=script&lang=js&"
import style0 from "./OtherRepay.vue?vue&type=style&index=0&id=f2903ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2903ad6",
  null
  
)

export default component.exports